import React, { useContext, useEffect, useState } from "react";
import { Button, ConfigProvider, Form, message, Modal, Select } from "antd";
import locale from "antd/es/locale/es_ES";
import { GetAllAules } from "../../../../dao/GetAllAules";
import JutgeColors from "../../../../styles/JutgeColors";
import { PostConjuntPildoresCopy } from "../../../../dao/jutge/PostConjuntPildoresCopy";
import { AuthContext } from "../../../../config/AuthContext";

interface Props {
    id_conjunt: number;
    nom?: string;
    visible: boolean;
    onClose: (updated: boolean) => void;
}

const CopyConjuntModal: React.FC<Props> = ({ id_conjunt, nom, visible, onClose }) => {
    const { userId } = useContext(AuthContext);
    const [aules, setAules] = useState<any[]>([]);
    const [selectedAules, setSelectedAules] = useState<number[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (visible) {
            GetAllAules("").then(data => setAules(data || [])).catch(() => {
                message.error("Error carregant les aules");
            });
        } else {
            setSelectedAules([]);
        }
    }, [visible]);

    const handleCancel = () => {
        setSelectedAules([]);
        onClose(false);
    };

    const handleCopy = async () => {
        if (!selectedAules.length) {
            message.warning("Selecciona almenys una aula");
            return;
        }
        try {
            setLoading(true);
            const res = await PostConjuntPildoresCopy(String(id_conjunt), selectedAules, userId);
            if (res && (res.status === 'ok' || res.id || res.ok !== false)) {
                message.success("Conjunt de píldores duplicat correctament!");
                onClose(true);
            } else {
                message.error((res && res.message) || "Error en duplicar el conjunt");
            }
        } catch (err) {
            message.error("Error en duplicar el conjunt de píldores");
        } finally {
            setLoading(false);
        }
    };

    return (
        <ConfigProvider locale={locale}>
            <Modal
                title={`Copiar Conjunt de Píldores${nom ? `: ${nom}` : ''}`}
                open={visible}
                onCancel={handleCancel}
                footer={null}
                width={520}
            >
                <Form layout="vertical">
                    <Form.Item
                        label="Selecciona les aules destinatàries"
                        tooltip="Es duplicarà el conjunt i totes les seves píldores a cada aula seleccionada"
                    >
                        <Select
                            mode="multiple"
                            placeholder="Selecciona les aules"
                            value={selectedAules}
                            onChange={(values) => setSelectedAules(values)}
                            style={{ width: "100%" }}
                            optionFilterProp="children"
                        >
                            {aules.map((aula: any) => (
                                <Select.Option key={aula.id} value={aula.id}>
                                    {aula.nom}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <div style={{ textAlign: "right", marginTop: 24 }}>
                        <Button onClick={handleCancel} style={{ marginRight: 8 }}>
                            Cancel·lar
                        </Button>
                        <Button
                            type="primary"
                            style={{ backgroundColor: JutgeColors.colors.color4, borderColor: JutgeColors.colors.color4 }}
                            loading={loading}
                            onClick={handleCopy}
                        >
                            Duplicar
                        </Button>
                    </div>
                </Form>
            </Modal>
        </ConfigProvider>
    );
};

export default CopyConjuntModal;
